<template>
    <div class="fluid">
        <h1 class="app-title">CONSULTA CDA WEBSERVICE SEFA</h1>
        <b-card>
            <b-row class="mb-2">
                <b-col md="2">
                    <b-form-group
                            label="Tipo da Consulta:"
                            label-for="valor"
                            class="text-label">
                        <b-form-select v-model="filtros.tipoConsulta" class="mb-3" @change="mainframeRetorno.codigoChamada = null">
                            <option
                                    v-for="tc in dados.tiposConsulta"
                                    :key="tc.id"
                                    :value="tc.id">
                                {{ tc.nome }}
                            </option>
                        </b-form-select>
                    </b-form-group>
                </b-col>

                <!-- ADICIONADO: ListBox "codOrgaoOrigemDivida" após "Tipo da Consulta" -->
                <b-col md="2">
                    <b-form-group
                        label="Órgão de Origem da Dívida:"
                        label-for="codOrgaoOrigemDivida"
                        class="text-label">
                        <b-form-select
                            id="codOrgaoOrigemDivida"
                            v-model="filtros.codOrgaoOrigemDivida"
                            :options="dados.orgaosOrigemDivida"
                            value-field="id"
                            text-field="nome"
                            class="mb-3"
                            :disabled="dados.orgaosOrigemDivida.length === 0">
                            <template #first>
                                <option :value="null">Selecione</option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                </b-col>

                <b-col md="2" v-if="filtros.tipoConsulta == 1">
                    <label>
                        Situação da(s) CDA(s):
                    </label>
                    <b-input v-model="filtros.dataConsulta" :max="maxDate" type="date" placeholder></b-input>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col md="6">
                    <b-form-group
                            label="Número da(s) CDA(s):"
                            label-for="textarea-formatter">
                        <b-form-textarea
                                id="numerosCda"
                                v-model="filtros.numerosCdas"
                                placeholder=""
                                max-rows="10"
                                style="max-height: 220px;"
                                @keyup="filtros.numerosCdas = formatarNumericoComEnter(filtros.numerosCdas)"
                        ></b-form-textarea>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-col md="3" style="padding: 0 !important;">
                <b-button @click="consultar"
                          variant="primary">
                    <i class="fa fa-search"></i> Pesquisar
                </b-button>
            </b-col>
            <b-row class="dadosSefa" v-if="mainframeRetorno.codigoChamada != null && filtros.tipoConsulta == 0">
                <p><strong>- DADOS</strong></p>
                <p class="ml-2"><strong>- CÓDIGO CHAMADA = </strong>{{ mainframeRetorno.codigoChamada }}</p>
                <p class="ml-2 mb-4"><strong>- MENSAGEM = </strong>{{ mainframeRetorno.mensagem }}</p>

                <p class="ml-2"><strong>- ENTRADA</strong></p>
                <p class="ml-4"><strong>- ORIGEM = </strong>{{ mainframeRetorno.origem }}</p>
                <p class="ml-4"><strong>- CHAVE = </strong>{{ mainframeRetorno.chave }}</p>
                <p class="ml-4 mb-4"><strong>- NÚMERO DA CDA = </strong>{{ mainframeRetorno.numeroCda }}</p>

                <p class="ml-2"><strong>- SAÍDA</strong></p>
                <p class="ml-2"><strong>- DADOS DA DíVIDA ATIVA</strong></p>
                <p class="ml-4"><strong>- CÓDIGO DO TIPO DE CRÉDITO = </strong>{{ mainframeRetorno.tipoCredito }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DO TIPO DE CRÉDITO = </strong>{{ mainframeRetorno.descricaoCredito }}</p>
                <p class="ml-4"><strong>- CÓDIGO DA REFERÊNCIA = </strong>{{ mainframeRetorno.tipoReferencia }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DA REFERÊNCIA = </strong>{{ mainframeRetorno.descricaoReferencia }}</p>
                <p class="ml-4"><strong>- NÚMERO REFERÊNCIA = </strong>{{ mainframeRetorno.numeroReferencia }}</p>
                <p class="ml-4"><strong>- DATA INSCRIÇÃO = </strong>{{ mainframeRetorno.dataInscricao }}</p>
                <p class="ml-4"><strong>- PRAZO FINAL = </strong>{{ mainframeRetorno.prazoFinal }}</p>
                <p class="ml-4"><strong>- DATA AJUIZADO = </strong>{{ mainframeRetorno.dataAjuizado }}</p>
                <p class="ml-4"><strong>- CÓDIGO MOEDA = </strong>{{ mainframeRetorno.codigoMoeda }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DA MOEDA = </strong>{{ mainframeRetorno.descricaoMoeda }}</p>
                <p class="ml-4"><strong>- CÓDIGO DA SITUAÇÃO = </strong>{{ mainframeRetorno.codigoSituacao }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DA SITUAÇÃO = </strong>{{ mainframeRetorno.descricaoSituacao }}</p>
                <p class="ml-4"><strong>- CÓDIGO DO STATUS = </strong>{{ mainframeRetorno.codigoStatus }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DO STATUS = </strong>{{ mainframeRetorno.descricaoStatus }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DAE = </strong>{{ mainframeRetorno.daeDescricao }}</p>
                <p class="ml-4 mb-4"><strong>- DAE SPI = </strong>{{ mainframeRetorno.daeSpi }}</p>

                <p class="ml-2"><strong>- DADOS DA DISTRIBUIÇÃO</strong></p>
                <p class="ml-4"><strong>- CÓDIGO DA COMARCA = </strong>{{ mainframeRetorno.codigoComarca }}</p>
                <p class="ml-4"><strong>- NOME DA COMARCA = </strong>{{ mainframeRetorno.nomeComarca }}</p>
                <p class="ml-4"><strong>- CÓDIGO DA VARA = </strong>{{ mainframeRetorno.codigoVara }}</p>
                <p class="ml-4"><strong>- NÚMERO DA DISTRIBUIÇÃO = </strong>{{ mainframeRetorno.numeroDistribuicao }}</p>
                <p class="ml-4"><strong>- NÚMERO DO RELATÓRIO = </strong>{{ mainframeRetorno.numeroRelatorio }}</p>
                <p class="ml-4"><strong>- NÚMERO DO PROCESSO = </strong>{{ mainframeRetorno.numeroProcesso }}</p>
                <p class="ml-4"><strong>- DATA DISTRIBUIÇÃO = </strong>{{ mainframeRetorno.dataDistribuicao }}</p>
                <p class="ml-4"><strong>- DADOS DA ÚLTIMA CERTIDÃO = </strong>{{ mainframeRetorno.dadosUltimaCertidao }}</p>
                <p class="ml-4"><strong>- CÓDIGO DA CERTIDÃO = </strong>{{ mainframeRetorno.codigoCertidao }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DA CERTIDÃO = </strong>{{ mainframeRetorno.descricaoCertidao }}</p>
                <p class="ml-4"><strong>- DATA EMISSÃO CDA = </strong>{{ mainframeRetorno.dataEmissaoCda }}</p>
                <p class="ml-4 mb-4"><strong>- HORA EMISSÃO CDA = </strong>{{ mainframeRetorno.horaEmissaoCda }}</p>

                <p class="ml-2"><strong>- DADOS DOS VALORES</strong></p>
                <p class="ml-4"><strong>- RUBRICAS</strong></p>
                <div class="w-100" v-for="(rubrica, index) in mainframeRetorno.listaRubricas" :key="rubrica.codigoRubrica">
                    <p class="ml-6"><strong>- CÓDIGO DA RUBRICA = </strong>{{ rubrica.codigoRubrica }}</p>
                    <p class="ml-6" :style="index < (mainframeRetorno.listaRubricas.length - 1) ? 'margin-bottom: 10px;' : ''"><strong>- DESCRIÇÃO DA RUBRICA = </strong>{{ rubrica.descricaoRubricao }}</p>
                </div>
                <p class="ml-4"><strong>- VALORES ORIGINAIS</strong></p>
                <div class="w-100" v-for="(valorOriginal, index) in mainframeRetorno.listaValoresOriginais" :key="valorOriginal.termoInicialAtualizacao">
                    <p class="ml-6"><strong>- TERMO INICIAL ATUALIZAÇÃO = </strong>{{ valorOriginal.termoInicialAtualizacao }}</p>
                    <p class="ml-6"><strong>- TERMO INICIAL JUROS = </strong>{{ valorOriginal.termoInicialJuros }}</p>
                    <p class="ml-6" :style="index < (mainframeRetorno.listaValoresOriginais.length - 1) ? 'margin-bottom: 10px;' : ''"><strong>- {{ valorOriginal.descricao }} = </strong>{{ valorOriginal.valor }}</p>
                </div>
                <p class="ml-4"><strong>- VALORES ATUALIZADOS</strong></p>
                <div class="w-100" v-for="(valorAtualizado, index) in mainframeRetorno.listaValoresAtualizados" :key="valorAtualizado.termoInicialAtualizacao">
                    <p class="ml-6"><strong>- TERMO INICIAL ATUALIZAÇÃO = </strong>{{ valorAtualizado.termoInicialAtualizacao }}</p>
                    <p class="ml-6"><strong>- TERMO INICIAL JUROS = </strong>{{ valorAtualizado.termoInicialJuros }}</p>
                    <p class="ml-6" :style="index < (mainframeRetorno.listaValoresAtualizados.length - 1) ? 'margin-bottom: 10px;' : ''"><strong>- {{ valorAtualizado.descricao }} = </strong>{{ valorAtualizado.valor }}</p>
                </div>
                <p class="ml-4"><strong>- DATA BASE IMPOSTO = </strong>{{ mainframeRetorno.dataBaseCda }}</p>
                <p class="ml-4"><strong>- DATA BASE MULTA = </strong>{{ mainframeRetorno.dataBaseMulta }}</p>
                <p class="ml-4"><strong>- DATA JUROS IMPOSTO = </strong>{{ mainframeRetorno.dataJuroCda }}</p>
                <p class="ml-4"><strong>- DATA JUROS MULTA = </strong>{{ mainframeRetorno.dataJuroMulta }}</p>
                <p class="ml-4"><strong>- VALOR BASE DO IMPOSTO = </strong>{{ mainframeRetorno.valorOriginal }}</p>
                <p class="ml-4"><strong>- VALOR BASE MULTA = </strong>{{ mainframeRetorno.multaOriginal }}</p>
                <p class="ml-4"><strong>- VALOR BASE JUROS = </strong>{{ mainframeRetorno.valorJuros }}</p>
                <p class="ml-4"><strong>- VALOR JUROS ATUALIZADO = </strong>{{ mainframeRetorno.valorAtualizado }}</p>
                <p class="ml-4 mb-4"><strong>- VALOR TOTAL = </strong>{{ mainframeRetorno.valorTotal }}</p>

                <p class="ml-2"><strong>- DADOS DOS DEVEDORES</strong></p>
                <p class="ml-4"><strong>- QUANTIDADE DE DEVEDORES = </strong>{{ mainframeRetorno.quantidadeDevedores }}</p>
                <div class="w-100" v-for="(devedor, index) in mainframeRetorno.listaDevedores" :key="devedor.codigoIdentificacao">
                    <p class="ml-6"><strong>- CÓDIGO DA IDENTIFICAÇÃO = </strong>{{ devedor.codigoIdentificacao }}</p>
                    <p class="ml-6"><strong>- DESCRIÇÃO DA IDENTIFICAÇÃO = </strong>{{ devedor.descricaoIdentificacao }}</p>
                    <p class="ml-6"><strong>- NÚMERO DE IDENTIFICAÇÃO = </strong>{{ devedor.numeroIdentificacao }}</p>
                    <p class="ml-6"><strong>- NOME DO DEVEDOR = </strong>{{ devedor.nomeDevedor }}</p>
                    <p class="ml-6"><strong>- TIPO DO LOGRADOURO ENDEREÇO = </strong>{{ devedor.tipoLogradouroEndereco }}</p>
                    <p class="ml-6"><strong>- NOME DO LOGRADOURO ENDEREÇO = </strong>{{ devedor.nomeLogradouroEndereco }}</p>
                    <p class="ml-6"><strong>- NÚMERO LOGRADOURO ENDEREÇO = </strong>{{ devedor.numeroLogradouroEndereco }}</p>
                    <p class="ml-6"><strong>- COMPL. LOGRADOURO ENDEREÇO = </strong>{{ devedor.complLogradouroEndereco }}</p>
                    <p class="ml-6"><strong>- BAIRRO DO ENDEREÇO = </strong>{{ devedor.bairroEndereco }}</p>
                    <p class="ml-6"><strong>- CEP DO ENDEREÇO = </strong>{{ devedor.cepEndereco }}</p>
                    <p class="ml-6"><strong>- CÓDIGO MUNICÍPIO ENDEREÇO = </strong>{{ devedor.codigoMunicipioEndereco }}</p>
                    <p class="ml-6"><strong>- NOME MUNICÍPIO ENDEREÇO = </strong>{{ devedor.nomeMunicipioEndereco }}</p>
                    <p class="ml-6"><strong>- UF DO ENDEREÇO = </strong>{{ devedor.ufEndereco }}</p>
                    <p class="ml-6"><strong>- CÓDIGO DA SITUAÇÃO = </strong>{{ devedor.situacao }}</p>
                    <p class="ml-6" :style="index < (mainframeRetorno.listaDevedores.length - 1) ? 'margin-bottom: 10px;' : 'margin-bottom: 40px;'">
                        <strong>- DESCRIÇÃO DA SITUAÇÃO = </strong>{{ devedor.descricaoSituacao }}</p>
                </div>

                <p class="ml-2"><strong>- DADOS DO PARCELAMENTO</strong></p>
                <p class="ml-4"><strong>- NÚMERO = </strong>{{ mainframeRetorno.numero }}</p>
                <p class="ml-4"><strong>- DATA = </strong>{{ mainframeRetorno.data }}</p>
                <p class="ml-4"><strong>- HORA = </strong>{{ mainframeRetorno.hora }}</p>
                <p class="ml-4"><strong>- MOTIVO = </strong>{{ mainframeRetorno.motivo }}</p>
                <p class="ml-4 mb-4"><strong>- QUANTIDADE DE PARCELAMENTOS = </strong>{{ mainframeRetorno.quantidadeParcelamentos }}</p>

                <p class="ml-2"><strong>- DADOS DOS BLOQUEIOS</strong></p>
                <p class="ml-4"><strong>- INDICADOR BLOQUEIO ATUAL = </strong>{{ mainframeRetorno.indicadorBloqueioAtual }}</p>
                <p class="ml-4"><strong>- QUANTIDADE DE BLOQUEIOS = </strong>{{ mainframeRetorno.quantidadeBloqueios }}</p>
                <div class="w-100" v-for="(devedor, index) in mainframeRetorno.listaBloqueios" :key="devedor.codigoTipo">
                    <p class="ml-6"><strong>- CÓDIGO TIPO BLOQUEIO = </strong>{{ devedor.codigoTipo }}</p>
                    <p class="ml-6"><strong>- DESCRIÇÃO TIPO BLOQUEIO = </strong>{{ devedor.descricaoBloqueio }}</p>
                    <p class="ml-6"><strong>- DATA BLOQUEIO = </strong>{{ devedor.dataBloqueio }}</p>
                    <p class="ml-6"><strong>- DATA LIBERAÇÃO = </strong>{{ devedor.dataLiberacao }}</p>
                    <p class="ml-6"><strong>- SPI BLOQUEIO = </strong>{{ devedor.spiBloqueio }}</p>
                    <p class="ml-6"><strong>- REFERÊNCIA BLOQUEIO = </strong>{{ devedor.referenciaBloqueio }}</p>
                    <p class="ml-6"><strong>- CMP BLOQUEIO = </strong>{{ devedor.cmpBloqueio }}</p>
                    <p class="ml-6" :style="index < (mainframeRetorno.listaBloqueios.length - 1) ? 'margin-bottom: 10px;' : ''">
                        <strong>- SPI LIBERAÇÃO = </strong>{{ devedor.spiLiberacao }}</p>
                </div>
            </b-row>
            <b-row class="dadosSefa" v-if="mainframeRetorno.codigoChamada != null && filtros.tipoConsulta == 1">
                <p><strong>- DADOS</strong></p>
                <p class="ml-2"><strong>- CÓDIGO CHAMADA = </strong>{{ mainframeRetorno.codigoChamada }}</p>
                <p class="ml-2 mb-4"><strong>- MENSAGEM = </strong>{{ mainframeRetorno.mensagem }}</p>

                <p class="ml-2"><strong>- ENTRADA</strong></p>
                <p class="ml-4"><strong>- ORIGEM = </strong>{{ mainframeRetorno.origem }}</p>
                <p class="ml-4"><strong>- QUANTIDADE DE OCORRÊNCIAS = </strong>{{ mainframeRetorno.qtdOcorrencias }}</p>
                <p class="ml-4"><strong>- NÚMERO DA CDA = </strong>{{ mainframeRetorno.numDa }}</p>
                <p class="ml-4 mb-4"><strong>- DATA BASE PESQUISA = </strong>{{ mainframeRetorno.dataBasePesquisa }}</p>

                <p class="ml-2"><strong>- SAÍDA</strong></p>
                <p class="ml-4"><strong>- NÚMERO DA CDA = </strong>{{ mainframeRetorno.numDaRetorno }}</p>
                <p class="ml-4"><strong>- CÓDIGO DO ERRO = </strong>{{ mainframeRetorno.rcTab }}</p>
                <p class="ml-4"><strong>- MENSAGEM DE ERRO = </strong>{{ mainframeRetorno.msgTab }}</p>
                <p class="ml-4"><strong>- CÓDIGO DO TIPO = </strong>{{ mainframeRetorno.codTipo }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DO TIPO = </strong>{{ mainframeRetorno.descTipo }}</p>
                <p class="ml-4"><strong>- CÓDIGO REFERÊNCIA = </strong>{{ mainframeRetorno.codRef }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DA REFERÊNCIA = </strong>{{ mainframeRetorno.descRef }}</p>
                <p class="ml-4"><strong>- CÓDIGO DA SITUAÇÃO = </strong>{{ mainframeRetorno.codSituacao }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DA SITUAÇÃO = </strong>{{ mainframeRetorno.descSituacao }}</p>
                <p class="ml-4"><strong>- CÓDIGO DO STATUS = </strong>{{ mainframeRetorno.codStatus }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DO STATUS = </strong>{{ mainframeRetorno.descStatus }}</p>
                <p class="ml-4"><strong>- INDICADOR DE COMPLEXIDADE = </strong>{{ mainframeRetorno.indComplexidade }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DE COMPLEXIDADE = </strong>{{ mainframeRetorno.descIndComplexidade }}</p>
                <p class="ml-4"><strong>- DATA ENCONTRADA = </strong>{{ mainframeRetorno.dataEncontrada }}</p>
                <p class="ml-4"><strong>- CÓDIGO MOEDA = </strong>{{ mainframeRetorno.moeda }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DA MOEDA = </strong>{{ mainframeRetorno.descMoeda }}</p>
                <p class="ml-4"><strong>- DATA BASE IMPOSTO = </strong>{{ mainframeRetorno.dataBaseImposto }}</p>
                <p class="ml-4"><strong>- DATA BASE MULTA = </strong>{{ mainframeRetorno.dataBaseMulta }}</p>
                <p class="ml-4"><strong>- DATA JUROS IMPOSTO = </strong>{{ mainframeRetorno.dataJurosImposto }}</p>
                <p class="ml-4"><strong>- DATA JUROS MULTA = </strong>{{ mainframeRetorno.dataJurosMulta }}</p>
                <p class="ml-4"><strong>- VALOR BASE DO IMPOSTO = </strong>{{ mainframeRetorno.valImpostoBase }}</p>
                <p class="ml-4"><strong>- VALOR BASE DA MULTA = </strong>{{ mainframeRetorno.valMultaBase }}</p>
                <p class="ml-4"><strong>- VALOR BASE DO JUROS = </strong>{{ mainframeRetorno.valJurosBase }}</p>
                <p class="ml-4 mb-4"><strong>- VALOR TOTAL ATUAL = </strong>{{ mainframeRetorno.valTotalAtual }}</p>

                <p class="ml-4"><strong>- DADOS DA SUSPENSÃO</strong></p>
                <p class="ml-6"><strong>- CÓDIGO SUSPENSÃO = </strong>{{ mainframeRetorno.tipoSuspensao }}</p>
                <p class="ml-6"><strong>- DESCRIÇÃO SUSPENSÃO = </strong>{{ mainframeRetorno.descricaoSuspensao }}</p>
                <p class="ml-6"><strong>- DATA INÍCIO SUSPENSÃO = </strong>{{ mainframeRetorno.dataInicioSuspensao }}</p>
                <p class="ml-6"><strong>- DATA FIM SUSPENSÃO = </strong>{{ mainframeRetorno.dataFimSuspensao }}</p>
                <p class="ml-6"><strong>- CMP SUSPENSÃO = </strong>{{ mainframeRetorno.complementoSuspensao }}</p>
            </b-row>
            <b-row class="dadosSefa" v-if="mainframeRetorno.codigoChamada != null && filtros.tipoConsulta == 2">
                <p><strong>- DADOS</strong></p>
                <p class="ml-2"><strong>- CÓDIGO CHAMADA = </strong>{{ mainframeRetorno.codigoChamada }}</p>
                <p class="ml-2 mb-4"><strong>- MENSAGEM = </strong>{{ mainframeRetorno.mensagem }}</p>

                <p class="ml-2"><strong>- ENTRADA</strong></p>
                <p class="ml-4"><strong>- ORIGEM = </strong>{{ mainframeRetorno.origem }}</p>
                <p class="ml-4"><strong>- NÚMERO DA CDA = </strong>{{ mainframeRetorno.numDa }}</p>

                <p class="ml-2"><strong>- SAÍDA</strong></p>
                <p class="ml-4"><strong>- CÓDIGO DO TIPO DE CRÉDITO = </strong>{{ mainframeRetorno.codTipo }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DO TIPO DE CRÉDITO = </strong>{{ mainframeRetorno.descTipo }}</p>
                <p class="ml-4"><strong>- CÓDIGO DA REFERÊNCIA = </strong>{{ mainframeRetorno.codRef }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DA REFERÊNCIA = </strong>{{ mainframeRetorno.descRef }}</p>
                <p class="ml-4"><strong>- CÓDIGO DA SITUAÇÃO = </strong>{{ mainframeRetorno.codSituacao }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DA SITUAÇÃO = </strong>{{ mainframeRetorno.descSituacao }}</p>
                <p class="ml-4"><strong>- CÓDIGO DA STATUS = </strong>{{ mainframeRetorno.codStatus }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DA STATUS = </strong>{{ mainframeRetorno.descStatus }}</p>
                <p class="ml-4"><strong>- DATA INSCRIÇÃO = </strong>{{ mainframeRetorno.dataInscricao }}</p>
                <p class="ml-4"><strong>- CÓDIGO DO TIPO DO DEVEDOR 1 = </strong>{{ mainframeRetorno.tipoDevedor1 }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DO TIPO DO DEVEDOR 1 = </strong>{{ mainframeRetorno.descTipoDevedor1 }}</p>
                <p class="ml-4"><strong>- IDENTIFICAÇÃO DO DEVEDOR 1 = </strong>{{ mainframeRetorno.identificacaoDevedor1 }}</p>
                <p class="ml-4"><strong>- CÓDIGO DO TIPO DO DEVEDOR 2 = </strong>{{ mainframeRetorno.tipoDevedor2 }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DO TIPO DO DEVEDOR 2 = </strong>{{ mainframeRetorno.descTipoDevedor2 }}</p>
                <p class="ml-4"><strong>- IDENTIFICAÇÃO DO DEVEDOR 2 = </strong>{{ mainframeRetorno.identificacaoDevedor2 }}</p>
                <p class="ml-4"><strong>- CÓDIGO DO TIPO DO DEVEDOR 3 = </strong>{{ mainframeRetorno.tipoDevedor3 }}</p>
                <p class="ml-4"><strong>- DESCRIÇÃO DO TIPO DO DEVEDOR 3 = </strong>{{ mainframeRetorno.descTipoDevedor3 }}</p>
                <p class="ml-4"><strong>- IDENTIFICAÇÃO DO DEVEDOR 3 = </strong>{{ mainframeRetorno.identificacaoDevedor3 }}</p>

                <p class="ml-4"><strong>- RUBRICA</strong></p>
                <div v-for="rubrica in mainframeRetorno.listaRubricas" :key="rubrica.codigoRubrica">
                    <p class="ml-6"><strong>- CÓDIGO DA RUBRICA = </strong>{{ rubrica.codigoRubrica }}</p>
                    <p class="ml-6"><strong>- DESCRIÇÃO DA RUBRICA = </strong>{{ rubrica.descRubrica }}</p>
                    <p class="ml-6"><strong>- VALOR DA RUBRICA = </strong>{{ rubrica.valorRubrica }}</p>
                    <p class="ml-6"><strong>- TERMO INICIAL ATUALIZAÇÃO = </strong>{{ rubrica.termoInicialAtualizacao }}</p>
                    <p class="ml-6" style="margin-bottom: 10px;"><strong>- TERMO INICIAL JUROS = </strong>{{ rubrica.termoInicialJuros }}</p>
                </div>
            </b-row>
            <b-row class="d-flex justify-content-between mt-4" v-if="mainframeRetorno.codigoChamada != null && filtros.tipoConsulta == 2">
                <b-col>
                    <CompBotaoExibirOcultarColuna
                            :fields="fields"
                            :showColunms="showColunms"
                            @toggleColuna="toggleColuna"/>
                    <span class="ml-2"><strong> Lista de Eventos</strong></span>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                    <b-form-select v-model="configTable.perPage" :options="[10, 100, 500, 1000, 'Todos']" size="sm"
                                   class="mb-3 col-2" style="float:right"></b-form-select>
                    <b-button class="ml-2" variant="secondary" @click="limparFiltros"
                              style="float: right; margin-right: 10px; height: 32px; padding: 0 0.75rem;">
                        <i class="fas fa-broom"></i> Limpar Filtros
                    </b-button>
                </b-col>
            </b-row>
            <TabelaBoletosNaoEncontrados
                    :resultado="items"
                    :fields="fields"
                    :configTable="configTable"
                    :filtro="filtros"
                    @openFilterPopup="openFilterPopup"
                    @consultar="consultar"
                    v-if="mainframeRetorno.codigoChamada != null && filtros.tipoConsulta == 2"/>
            <b-row class="d-flex justify-content-between" style="margin-top: 10px;" v-if="mainframeRetorno.codigoChamada != null && filtros.tipoConsulta == 2">
                <b-col>
                </b-col>
                <b-col style="display: flex; justify-content: center;">
                    <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage"
                                  :total-rows="configTable.rows" size="sm" class="pl-3" style="padding: 0 !important;"
                                  v-if="configTable.perPage != 'Todos'">
                    </b-pagination>
                </b-col>
                <b-col>
                </b-col>
            </b-row>
        </b-card>
        <CompFiltroGrid
                ref="compFiltro"
                :filtro="filtro"
                @filtrarResultados="filtrarResultados"
                @ordenarResultados="ordenarResultados"/>
        <CompLoading ref="loading"/>
    </div>
</template>
<script>
    import Multiselect from 'vue-multiselect'
    import axios from 'axios'
    import TabelaBoletosNaoEncontrados from "./TabelaCdaWebService";
    import CompBotaoExibirOcultarColuna from "../shared/components/CompBotaoExibirOcultarColuna";
    import CompFiltroGrid from "../shared/components/CompFiltroGrid";
    import CompLoading from "../shared/components/CompLoading";
    import formatarMixins from '../../mixins/formatarMixins';

    export default {
        mixins: [ formatarMixins ],
        components: {CompLoading, CompFiltroGrid, CompBotaoExibirOcultarColuna, TabelaBoletosNaoEncontrados, Multiselect},
        data() {
            return {
                urlApi: null,
                token: null,
                maxDate: null,
                mainframeRetorno: {
                    codigoChamada: null,
                    mensagem: null,
                    origem: null,
                    qtdOcorrencias: null,
                    numDa: null,
                    dataBasePesquisa: null,
                    numDaRetorno: null,
                    rcTab: null,
                    msgTab: null,
                    codTipo: null,
                    descTipo: null,
                    codRef: null,
                    descRef: null,
                    codSituacao: null,
                    descSituacao: null,
                    indComplexidade: null,
                    dataEncontrada: null,
                    moeda: null,
                    descMoeda: null,
                    dataBaseImposto: null,
                    dataBaseMulta: null,
                    dataJurosImposto: null,
                    dataJurosMulta: null,
                    valImpostoBase: null,
                    valMultaBase: null,
                    valJurosBase: null,
                    valTotalAtual: null
                },
                dados: {
                    tiposConsulta: [
                        {id: 0, nome: "Consulta Detalhada"},
                        {id: 1, nome: "Consulta Situação Dívida"},
                        {id: 2, nome: "Consulta Eventos"}
                    ],
                    // ADICIONADO: lista de opções do ListBox
                    orgaosOrigemDivida: []
                },
                fields: [],
                items: [],
                configTable: {
                    perPage: 10,
                    lastPage: null,
                    sortField: 'dataEvento',
                    sortOrder: 'desc',
                    currentPage: 1,
                    rows: 0,
                    checkedAll: false,
                    load: false,
                },
                showColunms: [],
                filtro: {
                    tipo: null,
                    campoFiltro: null,
                    filtrarEm: null,
                    mascara: null,
                    campoTexto: null,
                    campoMascara: null,
                    campoData: null,
                    campoRadio: null,
                    campoCheckbox: null,
                    listaValores: []
                },
                filtros: {
                    tipoConsulta: 0,
                    dataConsulta: null,
                    numerosCdas: null,
                    codOrgaoOrigemDivida: null,
                    filtrarDataEvento: null,
                    dataEvento: null,
                    filtrarDataFim: null,
                    dataFim: null,
                    codigo: null,
                    filtrarDescricao: null,
                    descricao: null,
                    moeda: null,
                    filtrarValor: null,
                    valor: null,
                    filtrarComplemento: null,
                    complemento: null
                }
            }
        },
        methods: {
            async consultar() {
                this.$store.commit("setMessages", {});

                if(this.filtros.numerosCdas == null || this.filtros.numerosCdas == "" || this.filtros.numerosCdas.trim() == "") {
                    this.exibirMensagem("O campo Número da(s) CDA(s) é obrigatório.");
                    return;
                }
                if(this.filtros.tipoConsulta == 1 && (this.filtros.dataConsulta == null || this.filtros.dataConsulta == "")) {
                    this.exibirMensagem("A data de Situação da(s) CDA(s) é obrigatória.");
                    return;
                }
                if(this.filtros.codOrgaoOrigemDivida == null || this.filtros.codOrgaoOrigemDivida == "") {
                    this.exibirMensagem("O Órgão de Origem da Dívida é obrigatório.");
                    return;
                }

                this.mainframeRetorno.codigoChamada = null;

                if(this.filtros.tipoConsulta == 0) {
                    this.$refs.loading.showLoading();
                    axios.post(`${this.urlApi}/v1/consultaCdaSefa/consultarCdaDetalhada`, this.filtros, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        this.tratarRetornoPesquisa(response);
                    }).catch((error) => {
                        this.exibirErro(error)
                    }).finally(() => {
                        this.$refs.loading.hideLoading();
                    })
                } else if(this.filtros.tipoConsulta == 1) {
                    this.$refs.loading.showLoading();
                    axios.post(`${this.urlApi}/v1/consultaCdaSefa/consultarSituacaoCda`, this.filtros, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        this.tratarRetornoPesquisa(response);
                    }).catch((error) => {
                        this.exibirErro(error)
                    }).finally(() => {
                        this.$refs.loading.hideLoading();
                    })
                } else if(this.filtros.tipoConsulta == 2) {
                    let perPageStr = `&perPage=${this.configTable.perPage}`;
                    if (this.configTable.perPage === 'Todos') {
                        perPageStr = '';
                        this.configTable.currentPage = 1;
                        this.configTable.rows = 0;
                    }

                    this.$refs.loading.showLoading();
                    axios.post(`${this.urlApi}/v1/consultaCdaSefa/consultarEventosCda?page=${this.configTable.currentPage}${perPageStr}&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, this.filtros, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(response => {
                        this.tratarRetornoPesquisa(response);
                        if(response.data != null && !Array.isArray(response.data)) {
                            this.items = response.data.pagina.resultado;

                            if (this.configTable.perPage !== 'Todos') {
                                this.configTable.rows = response.data.pagina.rows;
                                this.configTable.lastPage = Math.ceil(this.configTable.rows / this.configTable.perPage);
                            } else {
                                this.configTable.lastPage = 1;
                            }
                        }
                    }).catch((error) => {
                        this.exibirErro(error)
                    }).finally(() => {
                        this.$refs.loading.hideLoading();
                    })
                }
            },

            tratarRetornoPesquisa(response) {
                if(response.data != null && Array.isArray(response.data)) {
                    axios.get(`${this.urlApi}/v1/consultaCdaSefa/downloadCsv/${response.data[0].arquivo}`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    }).then(responseCsv => {
                        const url = window.URL.createObjectURL(new Blob([responseCsv.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', 'ConsultaCDASEFA.csv');
                        document.body.appendChild(link);
                        link.click();
                    });
                } else {
                    this.mainframeRetorno = response.data;
                }
            },

            prevPage() {
                this.configTable.currentPage = this.configTable.currentPage - 1;
                this.consultar();
            },

            nextPage() {
                this.configTable.currentPage = this.configTable.currentPage + 1;
                this.consultar();
            },

            async obterColunasUsuario() {
                const funcionalidade = 'consultaCdaWebserviceSefa';

                this.configTable.load = true;
                axios.get(`${this.urlApi}/v1/funcionalidade/configuracao/${funcionalidade}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).then(response => {
                    response.data.forEach((field, i) => {
                        if (field.ativo) {
                            this.showColunms.push(i)
                        }
                        this.fields.push({
                            key: `${i}`,
                            label: `${field.descricao}`,
                            thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                            codColunaFuncionalidade: field.codColunaFuncionalidade,
                            codFuncionalidade: field.codFuncionalidade
                        })
                    })
                }).catch((error) => {
                    this.exibirErro(error)
                }).finally(() => {
                    this.configTable.load = false;
                })
            },

            toggleColuna(i) {
                let ativo;
                if (this.showColunms.includes(i)) {
                    this.showColunms.splice(this.showColunms.indexOf(i), 1);
                    this.fields[i].thClass = 'd-none';
                    this.fields[i].tdClass = 'd-none';
                    ativo = false
                } else {
                    this.showColunms.push(i);
                    this.fields[i].thClass = '';
                    this.fields[i].tdClass = '';
                    ativo = true
                }

                this.atualizarConfiguracaoColunm(i, ativo)
            },

            async atualizarConfiguracaoColunm(i, ativo) {
                const json = {
                    codFuncionalidade: this.fields[i].codFuncionalidade,
                    codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                    ativo,
                };
                axios.put(`${this.urlApi}/v1/funcionalidade/configuracao`, json, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': this.token
                    }
                }).catch((error) => {
                    this.exibirErro(error)
                })
            },

            openFilterPopup(campo, tipo, values, mascara, event) {
                if(document.getElementById('popup').style.display == 'block'
                    && this.filtro.campoFiltro == campo) {
                    this.$refs.compFiltro.closeFilterPopup();
                } else {
                    this.filtro.tipo = tipo;
                    this.filtro.campoFiltro = campo;
                    this.filtro.mascara = mascara;
                    if(this.filtro.campoFiltro == 'Data Evento') {
                        this.filtro.filtrarEm = this.filtros.filtrarDataEvento;
                        this.filtro.campoData = this.filtros.dataEvento;
                    } else if(this.filtro.campoFiltro == 'Data Fim') {
                        this.filtro.filtrarEm = this.filtros.filtrarDataFim;
                        this.filtro.campoData = this.filtros.dataFim;
                    } else if(this.filtro.campoFiltro == 'Código') {
                        this.filtro.campoMascara = this.filtros.codigo;
                    } else if(this.filtro.campoFiltro == 'Descrição') {
                        this.filtro.filtrarEm = this.filtros.filtrarDescricao;
                        this.filtro.campoTexto = this.filtros.descricao;
                    } else if(this.filtro.campoFiltro == 'Moeda') {
                        this.filtro.campoMascara = this.filtros.moeda;
                    } else if(this.filtro.campoFiltro == 'Valor') {
                        this.filtro.filtrarEm = this.filtros.filtrarValor;
                        this.filtro.campoTexto = this.filtros.valor;
                    } else if(this.filtro.campoFiltro == 'Complemento') {
                        this.filtro.filtrarEm = this.filtros.filtrarComplemento;
                        this.filtro.campoTexto = this.filtros.complemento;
                    }

                    if(this.filtro.tipo == "checkbox") {
                        this.filtro.listaValores = values;
                    } else if(values != null && values != "") {
                        this.filtro.listaValores = values.split(',');
                    }

                    this.$refs.compFiltro.openCloseFilterPopup(event);
                }
            },
            filtrarResultados(limpar) {
                if(limpar) {
                    this.filtro.filtrarEm = null;
                    this.filtro.campoTexto = null;
                    this.filtro.campoMascara = null;
                    this.filtro.campoData = null;
                    this.filtro.campoRadio = null;
                    this.filtro.campoCheckbox = null;
                }

                if(this.filtro.campoCheckbox != null && !Array.isArray(this.filtro.campoCheckbox)) {
                    this.filtro.campoCheckbox = [this.filtro.campoCheckbox];
                }

                if(this.filtro.campoFiltro == 'Data Evento') {
                    this.filtros.filtrarDataEvento = this.filtro.filtrarEm;
                    this.filtros.dataEvento = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Data Fim') {
                    this.filtros.filtrarDataFim = this.filtro.filtrarEm;
                    this.filtros.dataFim = this.filtro.campoData;
                } else if(this.filtro.campoFiltro == 'Código') {
                    this.filtros.codigo = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Descrição') {
                    this.filtros.filtrarDescricao = this.filtro.filtrarEm;
                    this.filtros.descricao = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Moeda') {
                    this.filtros.moeda = this.filtro.campoMascara;
                } else if(this.filtro.campoFiltro == 'Valor') {
                    this.filtros.filtrarValor = this.filtro.filtrarEm;
                    this.filtros.valor = this.filtro.campoTexto;
                } else if(this.filtro.campoFiltro == 'Complemento') {
                    this.filtros.filtrarComplemento = this.filtro.filtrarEm;
                    this.filtros.complemento = this.filtro.campoTexto;
                }

                this.configTable.currentPage = 1;

                this.consultar();
            },
            ordenarResultados(order) {
                if(this.filtro.campoFiltro == 'Data Evento') {
                    this.configTable.sortField = 'dataEvento';
                } else if(this.filtro.campoFiltro == 'Data Fim') {
                    this.configTable.sortField = 'dataFim';
                } else if(this.filtro.campoFiltro == 'Código') {
                    this.configTable.sortField = 'codigo';
                } else if(this.filtro.campoFiltro == 'Descrição') {
                    this.configTable.sortField = 'descricao';
                } else if(this.filtro.campoFiltro == 'Moeda') {
                    this.configTable.sortField = 'moeda';
                } else if(this.filtro.campoFiltro == 'Valor') {
                    this.configTable.sortField = 'valor';
                } else if(this.filtro.campoFiltro == 'Complemento') {
                    this.configTable.sortField = 'complemento';
                }

                this.configTable.sortOrder = order;

                this.consultar();
            },
            limparFiltros() {
                this.filtros = {
                    tipoConsulta: this.filtros.tipoConsulta,
                    dataConsulta: null,
                    numerosCdas: null,
                    filtrarDataEvento: null,
                    dataEvento: null,
                    filtrarDataFim: null,
                    dataFim: null,
                    codigo: null,
                    filtrarDescricao: null,
                    descricao: null,
                    moeda: null,
                    filtrarValor: null,
                    valor: null,
                    filtrarComplemento: null,
                    complemento: null
                };

                this.consultar();
            },

            // ADICIONADO: busca opções via AJAX
            async obterOrgaosOrigemDivida() {
                try {
                    const response = await axios.get(`${this.urlApi}/v1/consultaCdaSefa/listarOrgaosOrigemDivida`, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': this.token
                        }
                    });
                    this.dados.orgaosOrigemDivida = response.data || [];
                } catch (error) {
                    this.exibirErro(error);
                }
            },
        },
        watch: {
            perPage() {
                this.configTable.currentPage = 1;
                this.consultar();
            }
        },
        computed: {
            perPage() {
                return this.configTable.perPage;
            },
        },
        mounted() {
            this.urlApi = process.env.VUE_APP_ROOT_API;
            this.token = JSON.parse(this.$store.getters.getUser).access_token;

            this.$store.commit("setMessages", {});

            var dataAtual = new Date();
            let ano = dataAtual.getFullYear();
            let mes = dataAtual.getMonth() + 1;

            this.filtros.dataConsulta = ano + "-" + (mes < 10 ? "0" : "") + mes + "-" + dataAtual.getDate();
            this.maxDate = ano + "-" + (mes < 10 ? "0" : "") + mes + "-" + dataAtual.getDate();

            this.obterColunasUsuario();
            // ADICIONADO: carregar opções do ListBox
            this.obterOrgaosOrigemDivida();
        }
    }
</script>
